import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";
import ProtectedRoute from "./Protected";

const ReporteGnvAvanzado = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [inspector, setInspector] = useState("");
  const [taller, setTaller] = useState("");
  const [regional, setRegional] = useState("");
  const [loading, setLoading] = useState(false);

  const [inspectoresList, setInspectoresList] = useState([]);
  const [talleresList, setTalleresList] = useState([]);
  const [regionalesList, setRegionalesList] = useState([]);

  useEffect(() => {
    cargarListas();
  }, []);

  const cargarListas = async () => {
    try {
      const [usuariosRes, talleresRes, regionalesRes] = await Promise.all([
        axios.get(
          "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerUsuarios",
        ),
        axios.get(
          "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerTalleres",
        ),
        axios.get(
          "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerRegional",
        ),
      ]);

      const inspectores = usuariosRes.data.filter((u) => u.tipoUsuarioId === 2);
      setInspectoresList(inspectores);
      setTalleresList(talleresRes.data);
      setRegionalesList(regionalesRes.data);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudieron cargar las listas", "error");
    }
  };

  const descargarExcel = async () => {
    if (!fechaInicio || !fechaFin) {
      Swal.fire(
        "Campos requeridos",
        "Debes seleccionar ambas fechas.",
        "warning",
      );
      return;
    }

    const payload = {
      inspector,
      nombretaller: taller,
      regional,
    };

    const url = `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerGnv/${fechaInicio}/${fechaFin}`;

    setLoading(true);
    try {
      const response = await axios.post(url, payload, {
        responseType: "blob", // 👈 importante para archivos
      });

      // Crear archivo descargable
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `ReporteGNV_${fechaInicio}_a_${fechaFin}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(link.href); // limpiar URL temporal
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Ocurrió un error al descargar el reporte.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Card className="shadow mb-4">
          <CardBody>
            <h4 className="mb-4">Reportes facturación GNV</h4>
            <Form>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label>Fecha Inicio:</Label>
                    <Input
                      type="date"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Fecha Fin:</Label>
                    <Input
                      type="date"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label>Inspector:</Label>
                    <Input
                      type="select"
                      value={inspector}
                      onChange={(e) => setInspector(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {inspectoresList.map((insp, idx) => (
                        <option key={idx} value={insp.nombre}>
                          {insp.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label>Taller:</Label>
                    <Input
                      type="select"
                      value={taller}
                      onChange={(e) => setTaller(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {talleresList.map((t, idx) => (
                        <option key={idx} value={t.nombreTaller}>
                          {t.nombreTaller}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label>Regional:</Label>
                    <Input
                      type="select"
                      value={regional}
                      onChange={(e) => setRegional(e.target.value)}
                    >
                      <option value="">Todas</option>
                      {regionalesList.map((r, idx) => (
                        <option key={idx} value={r.nombre}>
                          {r.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <div className="text-right">
                <Button
                  color="success"
                  onClick={descargarExcel}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" className="mr-2" /> Descargando...
                    </>
                  ) : (
                    "Descargar Excel"
                  )}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </ProtectedRoute>
  );
};

export default ReporteGnvAvanzado;
